import escapeRegExp from './escapeRegExp';

const removeTrailingCharacters = (
  text: string | null | undefined,
  charToRemove: string,
): string | null | undefined => {
  if (!text) {
    return text;
  }

  const escapedCharToRemove = escapeRegExp(charToRemove);

  if (!escapedCharToRemove) return text;

  const regex = new RegExp(`${escapedCharToRemove}+$`, 'u');

  return text.replace(regex, '');
};

export default removeTrailingCharacters;
